import React, { Component } from 'react'
import { navigateTo } from 'gatsby-link'

import 'bootstrap/dist/css/bootstrap.css'
import './HeroForm.css'

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&')
}

class ContactCouncilForm extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSubmit = e => {
    e.preventDefault()
    const form = e.target
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({
        'form-name': form.getAttribute('name'),
        ...this.state,
      }),
    })
      .then(() => navigateTo(form.getAttribute('action')))
      .catch(error => alert(error))
  }

  render() {
    return (
      <form
        name="signup"
        className="form-inline"
        method="post"
        action="/thanks/"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        onSubmit={this.handleSubmit}
      >
        <input type="hidden" name="form-name" value="signup" />
        <p hidden>
          <label>
            Don’t fill this out:{' '}
            <input name="bot-field" onChange={this.handleChange} />
          </label>
        </p>
        <div className="form-group row p-3 p-md-4 container">
          <h3 className="col-12 mb-3" style={{ textAlign: 'center' }}>
            Stay up to date with our campaign
          </h3>
          <label className="sr-only" htmlFor="email">
            Email
          </label>
          <input
            className="form-control form-control-lg col-12 mb-2"
            name="email"
            type="text"
            placeholder="Email"
            onChange={this.handleChange}
          />
          <label className="sr-only" htmlFor="zipcode">
            Zipcode
          </label>
          <input
            className="form-control form-control-lg col-12 mb-2"
            name="zipcode"
            type="text"
            placeholder="Zipcode"
            onChange={this.handleChange}
          />
          <label className="sr-only" htmlFor="publicSupport">
            Would you like to be listed as a public supporter?
          </label>
          <select
            className="custom-select mb-2 col-12 form-control form-control-lg"
            name="publicSupport"
            onChange={this.handleChange}
            defaultValue={0}
          >
            <option value={0}>Show me as a public supporter?</option>
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
          <button className="col-12 mb-2 btn btn-success btn-lg" type="submit">
            Submit
          </button>
        </div>
      </form>
    )
  }
}

export default ContactCouncilForm



// WEBPACK FOOTER //
// ./src/components/StoryForm.js